import { TaskBagOfHoursModelType } from '@teinor/erp/types/company/task/taskBagOfHours'
import { useCallback, useEffect, useState } from 'react'
import { ConnectedProps, connect } from 'react-redux'
import { ButtonOrLoader, ButtonPrimary } from '../../../../../baseComponents/Button'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import { CheckboxMargin } from '../../../../../forms/Checkbox'
import { InputHidden } from '../../../../../forms/Input'
import { InputHourMinSecUnlimitedStateFull } from '../../../../../forms/Input/InputHourMinSec/InputHourMinSecUnlimited'
import TwinForm from '../../../../../forms/TwinForm'
import { BeforeSubmitHandler } from '../../../../../forms/TwinForm/types'
import { twinFetchPostJSON } from '../../../../../utils/globals/data'
import { displayFormatedHourFromSecs } from '../../../../../utils/globals/date'
import withLoading from '../../../../../utils/hoc/withLoading'
import useIsLoading from '../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../utils/reducers'
import { CustomerPayload } from '../../../../../utils/reducers/customers/customer'
import { getBottomNavApp } from '../../../../../utils/reducers/getters'
import { addBottomNavAppElement, changeErrorMessage } from '../../../../../utils/reducers/reduxDispatch'
import { TaskExtendedTy } from '../../types'
import { ModalTaskInvertedTimeBaseProps } from '../types'
import CustomError from '../../../../../baseComponents/CustomError'
import TwinToolTip from '../../../../../baseComponents/TwinToolTip'

type ModalTaskAddTimeProps = ModalTaskAddTimeLogicProps & ReduxModalTaskAddTime & { }

const ModalTaskAddTime: React.FC<ModalTaskAddTimeProps> = ({ setOpenModalInvertedTime, data }) => {
    const { t } = useTwinTranslation()
    const { selectedBagOfHours, bagOfHours, handleSelectBagOfHours, startToWork, isWorking, loading, endLoading, handleBeforeSubmit } = useModalTaskAddTimeLogic({ data, setOpenModalInvertedTime })
    const renderThis: JSX.Element[] = []
    const renderOtherBagsOfHours: JSX.Element[] = []
    let warningText = data?.CustomerProject?.id ? t('thereArentBagsOfHours', 'Este proyecto no tiene bolsas de horas') : t('thereIsntAProject', 'No hay ningún proyecto asignado para ver las bolsas de horas')
    if (data?.CustomerProject && bagOfHours?.length) {
        for (const bagOfHour of bagOfHours) {
            const myBagOfHour: any = bagOfHour
            const parsedLimitTime = displayFormatedHourFromSecs(bagOfHour.timeLimit)
            const parsedConsumedTime = displayFormatedHourFromSecs(bagOfHour.consumedTime)
            const parsedRemainingTime = displayFormatedHourFromSecs(bagOfHour.remainingTime)
            const projectName =  bagOfHour.CustomerProject?.name + ' - ' + bagOfHour?.CustomerProject?.CustomerProjectType?.name
            const parsedName = myBagOfHour?.name + ' - ' + parsedConsumedTime + '/' + parsedLimitTime + ' (' + t('remain', 'Quedan') + ' ' + parsedRemainingTime + ')'
            if (bagOfHour.CustomerProjectId === data?.CustomerProjectId) {
                renderThis.push(
                    <CheckboxMargin key={myBagOfHour.id} checked={selectedBagOfHours === bagOfHour.id} className={bagOfHour.remainingTime <= 0 ? 'text-red-BA' : ''} onChange={() => handleSelectBagOfHours(bagOfHour.id)} label={parsedName} />
                )
            } else {
                renderOtherBagsOfHours.push(
                    <div>
                        <TwinToolTip place='top' anchorSelect={'#BagOfHour' + bagOfHour.id} clickable>
                            <div>{projectName}</div>
                        </TwinToolTip>
                        <div id={'BagOfHour' + bagOfHour.id}>
                            <CheckboxMargin key={myBagOfHour.id} checked={selectedBagOfHours === bagOfHour.id} className={bagOfHour.remainingTime <= 0 ? 'text-red-BA' : ''} onChange={() => handleSelectBagOfHours(bagOfHour.id)} label={parsedName} />
                        </div>
                    </div>
                )
            }
        }
    }

    return (
        <TwinForm action='/api/app/task/workLog/createTaskWorkLog' beforeSubmitHandler={handleBeforeSubmit} onSubmit={() => setOpenModalInvertedTime(null)} onError={endLoading} className='flex-auto flex flex-col h-1'>
            <h2>
                <TwinTrans transKey='workIn'>Trabajar en</TwinTrans>
            </h2>
            <div className='mt-10'>
                <TwinTrans transKey='selectBagOfHoursOrNotToWork'>
                    Selecciona una de las bolsas de horas del proyecto asignado, o puedes no seleccionar ninguna para trabajar en la tarea únicamente.
                </TwinTrans>
            </div>
            <div className='my-5'>
                <div className='mb-5'>{renderThis.length
                    ? renderThis
                    : <CustomError textError={warningText} className='mt-5' />
                }
                </div>
                { renderOtherBagsOfHours.length > 0
                    ? <div>
                        <p>
                            <TwinTrans transKey='otherCustomerBagsOfHours'>
                            Otras bolsas de horas del cliente:
                            </TwinTrans>
                        </p>
                        {renderOtherBagsOfHours}
                    </div>
                    : null
                }
            </div>
            <div className='mt-10'>
                <TwinTrans transKey='canIntroduceHours'>
                    Puedes introducir manualmente las horas que has invertido en la tarea:
                </TwinTrans>
            </div>
            <InputHidden name='startDate' value={new Date().toISOString()} />
            <InputHidden name='endDate' value={new Date().toISOString()} />
            <InputHidden name='TaskBagOfHoursId' value={selectedBagOfHours||undefined} />
            <InputHidden name='TaskId' value={data?.id} />
            <div className='flex items-end'>
                <div className='flex flex-auto'>
                    <InputHourMinSecUnlimitedStateFull className='w-auto' label='' name='workedSecs' />
                </div>
                <ButtonOrLoader className='ml-20' buttonIsDisabled={loading} textButton={t('addTime', 'Añadir tiempo')} />
            </div>
            <div className='mt-30'>
                <TwinTrans transKey='orYouCanStartChrono'>
                    O bien puedes empezar un temporizador para controlar el tiempo que inviertes en la tarea 
                </TwinTrans>
            </div>
            <div className='mt-30'>
                <ButtonPrimary onClick={startToWork} type='button' disabled={isWorking}>
                    <TwinTrans transKey='startWorking'>
                        Empezar a trabajar
                    </TwinTrans>
                </ButtonPrimary>
            </div>
        </TwinForm>
    )
}


interface ModalTaskAddTimeLogicProps extends ModalTaskInvertedTimeBaseProps  {
    data: TaskExtendedTy
}

const useModalTaskAddTimeLogic = ({ data, setOpenModalInvertedTime }: ModalTaskAddTimeLogicProps) => {
    const [bagOfHours, setBagOfHours] = useState<TaskBagOfHoursModelType[] | null>(null)
    const [selectedBagOfHours, setSelectedBagOfHours] = useState<number | null>(null)
    const {t} = useTwinTranslation()
    const bottomNavApp = getBottomNavApp()
    const isWorking = bottomNavApp['workingModal'] ? true : false
  
    
    const errorAddTime = t('mustAddTime', 'Debe añadir tiempo')
    const { startLoading, endLoading, loading } = useIsLoading()

    const handleSelectBagOfHours = useCallback((id: number) => {
        setSelectedBagOfHours((old) => {
            if (old === id) {
                return null
            }
            return id
        })
    }, [setSelectedBagOfHours])
    
    const handleBeforeSubmit: BeforeSubmitHandler = useCallback((values: any) => {
        startLoading?.()
        if(parseInt(String(values.workedSecs)) === 0){
            changeErrorMessage(errorAddTime)
            endLoading?.()
            return false
        }
        return true
    }, [errorAddTime, startLoading, endLoading])

    const getBagOfHours = useCallback(async(CustomerProjectId: number, CustomerId: number) => {
        const result = await twinFetchPostJSON('/api/app/task/bagOfHours/getAllTaskBagsOfHoursForWork', {CustomerId, CustomerProjectId})
        if(result){
            setBagOfHours(result)
        }
    }, [setBagOfHours])

    const startToWork = useCallback(async () => {
        const now = new Date()
        const result = await twinFetchPostJSON('/api/app/task/workLog/createTaskWorkLog', { TaskId: String( data?.id), startDate: now.toISOString(), TaskBagOfHoursId: selectedBagOfHours })
        if (result) {
            addBottomNavAppElement({ type: 'workingModal', key: 'workingModal', extraData: { id: result.id, name: data?.name, TaskId: String(data?.id), startDate: now.toISOString(), TaskBagOfHoursId: selectedBagOfHours  } })
            setOpenModalInvertedTime(null)
        }
    }, [data?.id, data?.name, setOpenModalInvertedTime, selectedBagOfHours])


    useEffect(() => {
        if(data?.CustomerProject){
            getBagOfHours(data?.CustomerProject.id, data?.CustomerProject?.CustomerId)
        }
    }, [data?.CustomerProject, getBagOfHours, data?.CustomerProject?.CustomerId])

    return { selectedBagOfHours, handleSelectBagOfHours, startToWork, isWorking, bagOfHours, endLoading, loading, handleBeforeSubmit }
}

const modalTaskAddTimeDispatch = {
    setCustomers: (payload: CustomerPayload) => ({ type: 'CHANGE_CUSTOMER', payload }),
}

type ReduxModalTaskAddTime = ConnectedProps<typeof modalTaskAddTimeConnect>
const mapModalTaskAddTimeConnector = (state: AllReduxPayloads) => ({ customers: state.customers })
const modalTaskAddTimeConnect = connect(mapModalTaskAddTimeConnector, modalTaskAddTimeDispatch)
const taskConnectLoading = withLoading(ModalTaskAddTime, [{ fetchUrl: '/api/app/customer/getAllCustomersComplete', propName: 'customers', setFunctionName: 'setCustomers' }])
const ModalTaskAddTimeConnect = modalTaskAddTimeConnect(taskConnectLoading)

export default ModalTaskAddTimeConnect